import { useQuery } from '@tanstack/react-query';

import { apiCall, apiClient } from 'shared/client/apiClient';
import { GetPBLDraftByIdResponseType } from 'shared/common/dtos/pbl/getPBLDraftById';

export const getPBLDraftById = async ({
  pblDraftId,
  includeDeleted
}: {
  pblDraftId: string;
  includeDeleted?: boolean;
}) => {
  // `apiCall` so a refusal throws with its status — a 404 must reach the route loader as not-found rather than
  // resolve as `undefined` data.
  const data = await apiCall(
    apiClient.GET('/pbl-drafts/{pblDraftId}', {
      params: { path: { pblDraftId }, query: { ...(includeDeleted && { includeDeleted: 'true' }) } }
    })
  );
  return data as any; //FIXME provide return type;
};

export const pblDraftByIdQueryKey = ({ pblDraftId }: { pblDraftId?: string }) => ['pbl-draft', { pblDraftId }] as const;

export const useGetPBLDraftByIdQuery = (pblDraftId: string) => {
  return useQuery<GetPBLDraftByIdResponseType>({
    queryKey: pblDraftByIdQueryKey({ pblDraftId }),
    queryFn: () => getPBLDraftById({ pblDraftId }),
    enabled: !!pblDraftId
  });
};
